import DataTable from 'react-data-table-component';
import tableStyleDefault from '../../../../../../../Services/tableStyleDefault';
import { paginationOptions } from '../../../../../../data/PagineteInfo';
import CustomLoader from '../../../../../../data/customLoader';
import React from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch, useAppSelector } from '../../../../../../../redux/store';
import { setSelectedRows } from '../../../../../../../redux/features/product/product-slice';

export function Comentarios() {
  const dispatch = useDispatch<AppDispatch>();
  const {comments, loading} = useAppSelector(({ productReducer }) => productReducer.value);

  const columns: any = [
    {
      name: "Código",
      sortable: true,
      width: "88px",
      center: true,
      selector: (row: any) =>  row?.id_pdv ?? row?.ItemKeyId,
    },
    {
      name: "Produto",
      minWidth: "190px",
      sortable: true,
      selector: (row: any) => row?.ItemDescription?.toUpperCase() ?? row?.sale_name?.toUpperCase()
    },

    {
      name: "Price",
      selector: (row: any) =>
        Number(row?.Price ?? row?.sale_price)?.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        }),
      width: "85px",
      center: true,
      sortable: true,
    },
  ];

  const handleRowSelected = (state: { selectedRows: any[] }) => {
    dispatch(setSelectedRows(state.selectedRows));
  };
  
  return (
    <div style={{ padding: "1rem 0", overflowX: "auto", height: "550px" }}>
      <DataTable
        columns={columns}
        data={comments}
        striped
        selectableRows
        onSelectedRowsChange={handleRowSelected}
        customStyles={tableStyleDefault}
        paginationComponentOptions={paginationOptions}
        progressPending={loading}
        progressComponent={<CustomLoader />}
        noDataComponent="Nenhuma informação foi encontrada."
      />
    </div>
  )
}